import {createSlice} from '@reduxjs/toolkit'


//start without anything
const initialState ={
    name:"",
    email:"",
    photo:""
};
//when I login Remember
const UserSlice = createSlice({
    name:"user",
    initialState,
    reducers:{
        setUserLoginDetails:(state,action)=>{
            state.name= action.payload.name;
            state.email=action.payload.email;
            state.photo= action.payload.photo;
        },
//when I logout Forgot

        setSignOutState: state=>{
            state.name=null;
            state.email=null;
            state.photo=null;
        }
    }
})

export const { setUserLoginDetails,setSignOutState} = UserSlice.actions;

export const selectUserName= (state)  => state.user.name
export const selectUserEmail= (state) => state.user.email
export const selectUserPhoto= (state) => state.user.photo

export default UserSlice.reducer